import * as React from "react";
import { Stack, Text } from "office-ui-fabric-react";
// import Icon from "@mdi/react";

export interface PageTitleProps {
  icon?: string;
  title: string;
  description?: string;
}

class PageTitle extends React.Component<PageTitleProps> {
  size = this.props.description ? 48 : 32;
  render() {
    return (
      <Stack horizontal verticalAlign="start">
        {this.props.icon && (
          <Stack.Item>
            {/* <Icon path={this.props.icon} style={{ fontSize: this.size, height: this.size, width: this.size, margin: 8 }} /> */}
            <img
              src={this.props.icon}
              alt="title-image"
              style={{ height: 44, width: 44 }}
            />
            {/* <FontIcon iconName={this.props.icon} style={{ fontSize: this.size, height: this.size, width: this.size, margin: 8 }} /> */}
          </Stack.Item>
        )}
        <Stack.Item className="ml-15">
          <Stack>
            <Stack.Item>
              <Text className="page-title">{this.props.title}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text className="page-title-description">
                {this.props.description}
              </Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    );
  }
}

export default PageTitle;
